<template>
    <!-- Overlay -->
    <v-dialog v-model="overlay" overlay-opacity="0.8" max-width="400" @click:outside="closeAction">
        <v-card flat rounded="lg" :color="theme.backgroundColor" :class="{'pt-4': !title}">
            <v-card-title v-if="title" class="text-center" :style="{'display': 'block', 'color': theme.textColor}">{{title}}</v-card-title>

            <v-card-text v-if="icon || text.length > 0" class="text-center pa-2" :style="{'color': theme.textColor}">
                <div v-if="icon" class="confirm-icon-ring mx-auto mb-5" :style="{'border-color': theme.textColor}">
                    <v-icon size="48" :color="iconColor || theme.textColor">{{icon}}</v-icon>
                </div>
                <div v-if="text.length > 0" class="px-5" :class="(isXsDevice)?'confirm-title-xs':'confirm-title'" v-html="text"></div>
            </v-card-text>

            <v-card-actions v-if="!disableButtons">
                <v-row align="center" justify="center" class="ma-0 mt-3">
                        <v-col v-if="txtDismiss.length > 0" cols="12" md="6" align="center">
                        <v-btn large depressed block dark rounded  @click="closeAction" >{{txtDismiss}}</v-btn>
                    </v-col>
                        <v-col cols="12" :md="txtDismiss.length > 0 ? 6 : 12" align="center">
                        <v-btn large depressed block :color="theme.btnColorPrimary"  rounded  dark @click="successAction" >{{txtAgree}}</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {layoutMixin} from "../../utils/layout-mixin";

export default {
    mixins: [layoutMixin],
    components:{

    },
    props:{
        value:{
            type:Boolean,
            default:false
        },
        title:{
            type:String,
            default: ""
        },
        text:{
            type:String,
            default: ""
        },
        // optional mdi icon shown in a ring above the text
        icon:{
            type:String,
            default: ""
        },
        // falls back to the theme text color
        iconColor:{
            type:String,
            default: ""
        },
        txtAgree:{
            type:String,
            default:'OK'
        },
        txtDismiss:{
            type:String,
            default: ""
        },
        disableButtons:{
            type:Boolean,
            default:false
        },
    },
    watch:{
        /* Init data on creation and on update */
        value: {
            handler(val) {
                this.overlay=val;
            },
            immediate: true
        },
    },
    computed:{

    },
    data: () => ({
        overlay: false,
    }),
    methods:{
        successAction(){
            this.$emit('success');
            this.closeAction();
        },
        closeAction(){
            this.overlay=false;
            this.$emit('input',false);
            this.$emit('close');
        },
        closeAndSuccessAction(){
            setTimeout(()=>{
                this.closeAction();
                this.successAction();
            },1000);
        }
    }
}
</script>

<style scoped>
.confirm-title{
    font-size:1.1em;
    font-weight:500;
}
.confirm-title-xs{
    font-size:1.2em;
    font-weight:500;
}
.confirm-btn-large{
    font-size:1em;
    font-weight:500;
}
.confirm-icon-ring{
    width:80px;
    height:80px;
    border-radius:50%;
    border:2px solid;
    display:flex;
    align-items:center;
    justify-content:center;
}
</style>
